export default __webpack_public_path__ + "static/media/open.02a8bfa1.svg";